import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonModule } from '@usitsdasdesign/dds-ng/button';
import { StickerModule } from '@usitsdasdesign/dds-ng/sticker';
import { InfoService } from './info.service';
import { Info } from './typings';
import { RouteGuardService } from '../services/route-guard.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-info',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    StickerModule,
  ],
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss'
})
export class InfoComponent implements OnInit {
  isPopupShown: boolean;
  infoTitle: string;
  safeInfoContentHtml: SafeHtml;
  showComponent: boolean;
  @Input() infoData: Info
  constructor(
    private sanitizer: DomSanitizer,
    private infoService: InfoService,
    private routeGuardService: RouteGuardService,
    private router: Router  
    
  ) { }

  ngOnInit(): void {
    this.showComponent = this.routeGuardService.shouldShowComponent();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.showComponent = this.routeGuardService.shouldShowComponent();
    });
    
    if (this.infoData && this.showComponent) {
      this.processInfoData(this.infoData);
    }
  }

  ngOnChanges(): void {
    if (this.infoData) {      
      this.processInfoData(this.infoData);
    }
  }
  private processInfoData(infoData: Info): void {
    this.safeInfoContentHtml = this.sanitizer.bypassSecurityTrustHtml(infoData.content);
  }

  getInfoData() {
    this.infoService.getInfoData().subscribe({
      next: (infoData: Info) => {
        this.infoTitle = infoData?.title;
        this.safeInfoContentHtml = this.sanitizer.bypassSecurityTrustHtml(infoData?.content);
      },
      error: (err) => {
        console.error('Error loading floating info data:', err);
      }
    })
  }

  onShownPopup(): void {
    this.isPopupShown = true;
  }

  onHiddenPopup(): void {
    this.isPopupShown = false;
  }
}
